const initState = {
	loading: false,
	halls: []
};

const hallFameReducer = (state = initState, action) => {
	switch (action.type) {
		case 'ADD_LOADING':
			return {
				...state,
				loading: action.payload,
			};

			case 'GET_HALL':
				return {
					...state,
					halls: action.payload,
				};
		default:
			return {
				...state,
			};
	}
};
export default hallFameReducer;
